import "../Page2/Page2.css"
import About from "./About/About"
import Skills from "./Skills/Skills"
export default function Page2( ){
    return <div 
    className="mainDiv"
    style={{
    }}>
        <div id="aboutSection" className="side1">
        <About/>
        </div> 
        <div className="side2">
            <Skills/>
        </div> 
    </div>
}